// Report page format — story 4-106 (P06 §4). ONE canonical source, on the
// frontend, for the physical dimensions behind `contracts/reports.js`'s
// `ReportStyle.pageSize` enum (`'A4' | 'letter'`) — `ReportCoverPage`'s own
// min-height and `ReportDesignerCanvas`'s page-shaped preview wrapper
// (`ReportDesigner.tsx`) both read this, so a third page size only needs one
// edit here. `backend/src/services/pdf/pdfExport.service.js`'s own
// `PAGE_FORMATS` is a necessarily separate, hand-maintained twin (frontend
// and backend are different runtimes) — Puppeteer resolves 'A4'/'Letter' to
// the SAME physical dimensions as `MM` below from its own built-in table, so
// the two stay in lockstep without sharing code, the same twin discipline
// `FONT_STACKS`/`TOKENS` at the top of that file already use for this exact
// report-rendering family.
export type ReportPageSize = 'A4' | 'letter';
// Story 4-114 — page orientation. Swaps which physical dimension is "width"
// vs "height"; every function below defaults to 'portrait' so a pre-4-114
// call site (there are several) keeps resolving the exact same value.
export type ReportPageOrientation = 'portrait' | 'landscape';

export const REPORT_PAGE_SIZE_MM: Record<ReportPageSize, { width: number; height: number }> = {
  A4: { width: 210, height: 297 },
  letter: { width: 215.9, height: 279.4 },
};

const resolve = (pageSize?: ReportPageSize | null): { width: number; height: number } =>
  REPORT_PAGE_SIZE_MM[pageSize as ReportPageSize] ?? REPORT_PAGE_SIZE_MM.A4;

export const reportPageWidthMm = (pageSize?: ReportPageSize | null, orientation?: ReportPageOrientation | null): number => {
  const { width, height } = resolve(pageSize);
  return orientation === 'landscape' ? height : width;
};
export const reportPageHeightMm = (pageSize?: ReportPageSize | null, orientation?: ReportPageOrientation | null): number => {
  const { width, height } = resolve(pageSize);
  return orientation === 'landscape' ? width : height;
};
